module.exports = {
  messages: {
    CN: {
      'captchaRecordList.emailOrPhone': '邮箱/电话',
      'captchaRecordList.sendTime': '发送时间',
      'captchaRecordList.sendScene': '发送场景',
      'captchaRecordList.sendContent': '发送内容',
      'captchaRecordList.sendResult': '发送结果',
      'captchaRecordList.sendScene1': '电话注册',
      'captchaRecordList.sendScene2': '电话找回密码',
      'captchaRecordList.sendScene3': '邮箱找回',
      'captchaRecordList.sendScene4': '验证邮箱',
      'captchaRecordList.sendScene5': '社会化登录绑定邮箱',
      'captchaRecordList.sendScene6': '社会化登录绑定电话',
      'captchaRecordList.sendScene7': '编辑电话',
      'captchaRecordList.sendScene8': '编辑邮箱',
      'captchaRecordList.sendScene9': '邮箱注册',
      "captchaRecordList.erpCustomerInfo": "得意先情報"
    },
    JP: {
      'captchaRecordList.emailOrPhone': 'メール/電話',
      'captchaRecordList.sendTime': '送信時間',
      'captchaRecordList.sendScene': '送信シナリオ',
      'captchaRecordList.sendContent': '送信内容',
      'captchaRecordList.sendResult': '送信結果',
      'captchaRecordList.sendScene1': '携帯番号で登録',
      'captchaRecordList.sendScene2': '携帯番号でパスワードを回復',
      'captchaRecordList.sendScene3': 'メールでパスワードを回復',
      'captchaRecordList.sendScene4': 'メールを検証',
      'captchaRecordList.sendScene5': 'SNSアカウントとメールを紐付け',
      'captchaRecordList.sendScene6': 'SNSアカウントと携帯番号を紐付け',
      'captchaRecordList.sendScene7': '電話を編集',
      'captchaRecordList.sendScene8': 'メールアドレスを編集',
      'captchaRecordList.sendScene9': 'メールで登録',
      "captchaRecordList.erpCustomerInfo": "得意先情報"
    }
  }
};